import { AnimatedFeature, Feature, StaticFeature } from "./FeaturesHint";

const testPronunciationScreen: StaticFeature = {
  type: "static",
  title: "Test your pronunciation for every phrase you learn",
  image: "https://imgs.duocards.com/onboarding/features/test-your-pronunciation.png"
};

const practiceWithAiScreen: StaticFeature = {
  type: "static",
  title: "Practice with your own AI teacher",
  image: "https://imgs.duocards.com/onboarding/features/practice-with-ai-teacher.png"
};
const earnFlamesScreen: StaticFeature = {
  type: "static",
  title: "Earn flames by learning and build Memo a village",
  image: "https://imgs.duocards.com/onboarding/features/earn-flames.png"
};

const chromeExtensionScreen: AnimatedFeature = {
  type: "animated",
  title: "Add words from a PC via Chrome Extensions",
  rive: "https://imgs.duocards.com/rive/onboarding-chrome.riv",
  texts: [
    {
      id: "Run-Original",
      text: "Word",
      translate: "front"
    },
    {
      id: "Run-Translate",
      text: "Word",
      translate: "back"
    }
  ]
};
export const defaultFeatures: Feature[] = [
  {
    type: "animated",
    title: "Add new words via the share button",
    rive: "https://imgs.duocards.com/rive/onboarding-web.riv"
  },
  {
    type: "animated",
    title: "Create custom cards in the app",
    rive: "https://imgs.duocards.com/rive/onboarding-add.riv",
    texts: [
      {
        id: "Run-Original",
        text: "Rabbit",
        translate: "front"
      },
      {
        id: "Run-Translate",
        text: "Rabbit",
        translate: "back"
      },
      {
        id: "Run-Save",
        text: "Save",
        translate: "app"
      }
    ]
  },
  chromeExtensionScreen,
  {
    type: "animated",
    title: "Learn grammar with our AI assistant",
    rive: "https://imgs.duocards.com/rive/onboarding-chat.riv",
    texts: [
      {
        id: "RunQuestion",
        text: "Question",
        translate: "front"
      },
      {
        id: "RunAnswer",
        text: "Answer",
        translate: "front"
      }
    ]
  }
];

export const abTest1Features: Feature[] = [testPronunciationScreen, practiceWithAiScreen, earnFlamesScreen];

export const abTest2Features: Feature[] = [
  testPronunciationScreen,
  practiceWithAiScreen,
  earnFlamesScreen,
  chromeExtensionScreen
];
